import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CaseData } from '../core/types';
import { extractTimeline } from '../core/timeline';

interface Props {
  caseData: CaseData;
}

const Timeline: React.FC<Props> = ({ caseData }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const entries = extractTimeline(caseData);
  if (entries.length === 0) return null;

  const hasFlagged = entries.some(e => e.flagged);

  return (
    <div className="timeline-panel">
      <div className="timeline-header" onClick={() => setExpanded(v => !v)}>
        <h2>
          🕒 {t('timeline.title')}
          {hasFlagged && <span className="timeline-warning-badge">⚠️ {t('timeline.conflictFound')}</span>}
        </h2>
        <span className="timeline-toggle">{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
        <div className="timeline-body">
          <div className="timeline-track">
            {entries.map((entry, idx) => (
              <div key={idx} className={`timeline-item ${entry.flagged ? 'flagged' : ''}`}>
                <div className="timeline-dot" />
                <div className="timeline-content">
                  <div className="timeline-date">
                    {entry.display}
                    {entry.approximate && <span className="timeline-approx">{t('timeline.approx')}</span>}
                    {entry.flagged && <span className="timeline-flag">⚠️</span>}
                  </div>
                  <div className="timeline-desc">{entry.description}</div>
                  <div className="timeline-source">{entry.source}</div>
                </div>
              </div>
            ))}
          </div>
          {hasFlagged && (
            <p className="timeline-hint">{t('timeline.conflictHint')}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Timeline;
